import { render, staticRenderFns } from "./Bottom-Button.vue?vue&type=template&id=6ae0a02b&"
import script from "./Bottom-Button.vue?vue&type=script&lang=js&"
export * from "./Bottom-Button.vue?vue&type=script&lang=js&"
import style0 from "./Bottom-Button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bottom-Button.vue"
export default component.exports